import React from "react";
const Refund = () => {
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div
        class="row"
        style={{ maxWidth: size.width >= 428 && "76%", margin: "0px auto" }}
      >
        <div
          class="col-75"
          style={{
            marginLeft: size.width <= 428 && 20,
            marginRight: size.width <= 428 && 20,
            padding: 0,
            marginBottom: 30,
          }}
        >
          <div
            class="container"
            style={{ padding: size.width <= 428 ? 16 : 0 }}
          >
            <h1
              className="rservez-vos-rendez raleway-extra-bold-eerie-black-50px"
              style={{ paddingBottom: 10, fontSize: "35px", marginTop: 50 }}
            >
              Politique d’annulation et de remboursement
            </h1>
            <p className="raleway-bold-black-22px" style={{ marginTop: 30 }}>
              Définitions
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">Utilisateur : </span>
              tout professionnel ou personne physique capable au sens des
              articles 1123 et suivants du Code civil, ou personne morale, qui
              visite le Site objet des présentes conditions générales.
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              <span className="raleway-bold-black-16px">Prestataire : </span>
              Professionnel inscrit sur le site souhaitant proposer ses services
              aux utilisateur et bénéficier des servies proposés par
              www.onfleek.re
            </p>
            <p className="raleway-bold-black-18px" style={{ marginTop: 30 }}>
              En cas d’annulation de l’Utilisateur :
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              Une fois l’acompte réglé, l’Utilisateur ne pourra plus se faire
              rembourser en cas d’annulation ou de non-présentation au
              rendez-vous conformément à l’article L214-1 du code de la
              consommation.
            </p>
            <p className="raleway-bold-black-18px" style={{ marginTop: 30 }}>
              En cas d’annulation du Prestataire :
            </p>
            <p style={{ marginTop: 20 }} className="roboto-normal-black-18px">
              Si pour une raison quelconque le Prestataire annule la réservation
              de l’Utilisateur, il se verra obligé de rembourser la totalité de
              l’acompte perçu (hors frais de service).
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refund;
